import { Box } from '@material-ui/core';
import styled from 'styled-components';

export const PageLinksInputsContainer = styled(Box)`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: flex-start;
`;

export const TextFieldContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
`;
